import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TagManager from 'react-gtm-module';

// Initialize GTM
const tagManagerArgs = {
  gtmId: 'GTM-WLWFJHWN'
};

TagManager.initialize(tagManagerArgs);

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();